import { RisksApi, Configuration as RiskConfig } from 'api/risk';
import { createApiConfig } from './adapters';

export const risksAPI = new RisksApi(createApiConfig(RiskConfig));
